import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { GUIDES, guidePath } from "@/data/guides_index";

// Sélection de guides : liste explicite (slugs) ou guides les plus utiles, hors page courante.
export default function PracticalGuideLinks({ exclude, slugs, limit = 3, title = "Guides pratiques décennale" }) {
  const guides = slugs
    ? slugs.map((slug) => GUIDES.find((g) => g.slug === slug)).filter(Boolean)
    : GUIDES.filter((g) => g.slug !== exclude).slice(0, limit);
  return (
    <section className="my-12" aria-label={title}>
      <h2 className="font-display text-2xl sm:text-3xl font-bold uppercase tracking-tight mb-6">{title}</h2>
      <div className="grid gap-4 md:grid-cols-3">
        {guides.map((guide) => (
          <Link key={guide.slug} to={guidePath(guide.slug)} className="group flex flex-col border border-ink/25 bg-white p-6 hover:border-accent">
            <h3 className="font-display text-xl font-bold mb-3 group-hover:text-accent">{guide.h1}</h3>
            <p className="text-sm leading-relaxed text-ink/75 mb-4">{guide.desc}</p>
            <span className="mt-auto flex items-center gap-2 text-sm font-bold">Lire le guide <ArrowUpRight aria-hidden="true" className="h-4 w-4" /></span>
          </Link>
        ))}
      </div>
    </section>
  );
}
